export const GOOGLE_MAPS_CONFIG = {
  API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyANDOz38MYH4U6s_MQGNpojqMAxmxOEBb4',
  PLACES_API_KEY: process.env.REACT_APP_GOOGLE_PLACES_API_KEY || 'AIzaSyB1aZyDor881qqer4Uo8OouSdCi1TTFMsI',
  
  DEFAULT_CENTER: {
    lat: -1.2876,
    lng: 36.8228
  },
  
  DEFAULT_ZOOM: 14,
  
  LIBRARIES: ['places', 'geometry', 'drawing']
};

export default GOOGLE_MAPS_CONFIG;
